__turbopack_context__.v({
  "activeDot": "HomepageBannerCarousel-module-scss-module__3eTPrW__activeDot",
  "banner": "HomepageBannerCarousel-module-scss-module__3eTPrW__banner",
  "bannerWrapper": "HomepageBannerCarousel-module-scss-module__3eTPrW__bannerWrapper",
  "dotsContainer": "HomepageBannerCarousel-module-scss-module__3eTPrW__dotsContainer",
  "homepageCarouselContainer": "HomepageBannerCarousel-module-scss-module__3eTPrW__homepageCarouselContainer",
  "iconButtonContainer": "HomepageBannerCarousel-module-scss-module__3eTPrW__iconButtonContainer",
  "inactiveDot": "HomepageBannerCarousel-module-scss-module__3eTPrW__inactiveDot",
});
